<template>
  <v-form @submit.prevent="getActionMethod">
    <v-container>
      <v-row align="center" justify="center">
        <span class="red--text font-weight-bold">{{
          formValidator.getError("non_field_errors")
        }}</span>
        <v-col md="6">
          <v-select
            v-model="formValues.link_of"
            label="Link Of"
            :error-messages="formValidator.getError('link_of')"
            :items="[
              'Facebook',
              'Gmail',
              'Aol',
              'Yahoo',
              'Hotmail',
              'Linkedin'
            ]"
          ></v-select>
          <v-text-field
            v-model="formValues.link"
            label="Link"
            :error-messages="formValidator.getError('link')"
          ></v-text-field>
        </v-col>
        <v-col md="12"> </v-col>
        <v-col md="6">
          <v-divider class="my-2"></v-divider>
          <v-btn
            :disabled="Object.keys(formValidator.errors).length > 0"
            class="primary"
            type="submit"
          >
            Save
          </v-btn>
          <v-btn type="reset">
            Reset
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import { FormValidator } from "rhr-core-shell";
export default {
  props: {
    actionData: {
      type: Object,
      required: false,
      default() {
        return {
          contact_person: "",
          link_of: "Facebook",
          link: ""
        };
      }
    },
    contactPersonData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formValues: { ...this.actionData },
      formValidator: new FormValidator()
    };
  },
  watch: {
    formValues: {
      handler() {
        this.formValidator.setError({});
      },
      deep: true
    }
  },
  methods: {
    getActionMethod() {
      if (this.formValues.id) return this.updateSocialLink();
      return this.createSocialLink();
    },
    createSocialLink() {
      const contactPersonSocialLinkAPI =
        "/api/v1/crm/contact-person-social-link/";
      this.formValues.contact_person = this.contactPersonData.id;
      this.$axios
        .$post(contactPersonSocialLinkAPI, this.formValues)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully created contact person social link!`,
            color: "green"
          });
          this.$emit("contactPersonSocialLinkFormResponse", "created");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        });
    },
    updateSocialLink() {
      const contactPersonSocialLinkAPI =
        "/api/v1/crm/contact-person-social-link/" + this.formValues.id + "/";
      this.$axios
        .$patch(contactPersonSocialLinkAPI, this.formValues)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully updated contact person social link!`,
            color: "green"
          });
          this.$emit("contactPersonSocialLinkFormResponse", "updated");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        });
    }
  }
};
</script>
